export default {
  'dashboard.monitor.realtimeTransaction': 'Hoạt động giao dịch thời gian thực',
  'dashboard.monitor.todayTransaction': 'Tổng giao dịch hôm nay',
  'dashboard.monitor.salesTarget': 'Tỷ lệ hoàn thành mục tiêu bán hàng',
  'dashboard.monitor.onlineUsers': 'Tổng số người đang online',
  'dashboard.monitor.transactionPerSecond': 'Tổng giao dịch mỗi giây',
  'dashboard.monitor.activityPrediction': 'Dự báo tình hình hoạt động',
  'dashboard.monitor.couponEfficiency': 'Hiệu suất làm việc nhân viên',
  'dashboard.monitor.categoryRatio': 'Tỷ lệ theo danh mục',
  'dashboard.monitor.hotSearch': 'Thị trường tiềm năng',
  'dashboard.monitor.resourceRemaining': 'Tài nguyên còn lại',
  'dashboard.monitor.targetEvaluation': 'Đánh giá mục tiêu',
  'dashboard.monitor.expectedToReach': 'Có khả năng đạt được kỳ vọng',
  'dashboard.monitor.excellent': 'Xuất sắc',
  'dashboard.monitor.billionYuan': 'tỷ VNĐ',
  'dashboard.monitor.yuan': '$',
};
